export function formatYearMonth(value: string | undefined, locale = 'pl'): string {
  if (!value) return '';
  const [year, month] = value.split('-');
  if (!year) return '';
  if (!month) return year;
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString(locale, { year: 'numeric', month: 'long' });
}

export function formatDateRange(
  start: string | undefined,
  end: string | undefined,
  options: { presentLabel?: string; locale?: string } = {},
): string {
  const { presentLabel = 'obecnie', locale = 'pl' } = options;
  const startStr = formatYearMonth(start, locale);
  const endStr = end ? formatYearMonth(end, locale) : presentLabel;
  if (!startStr && !endStr) return '';
  if (!startStr) return endStr;
  return `${startStr} - ${endStr}`;
}

export function nowIso(): string {
  return new Date().toISOString();
}
